const owners = new Set()
let restoreBodyStyles

export function acquireBodyScrollLock() {
	const owner = {}
	if (!owners.size) {
		const body = document.body
		const overflow = body.style.overflow
		const paddingRight = body.style.paddingRight
		const scrollbarWidth =
			window.innerWidth - document.documentElement.clientWidth
		body.style.overflow = 'hidden'
		if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`
		restoreBodyStyles = () => {
			body.style.overflow = overflow
			body.style.paddingRight = paddingRight
		}
	}
	owners.add(owner)
	return () => {
		if (!owners.delete(owner) || owners.size) return
		restoreBodyStyles()
		restoreBodyStyles = null
	}
}
